/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import axios from 'axios'
import Vue from 'vue'

export default {
  methods: {
    downloadAd (adId, imageUrl) {
      const customAxios = axios.create()
      return customAxios({
        url: imageUrl,
        method: 'GET',
        responseType: 'blob'
      })
        .then((response) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.download = `${this.generateUniqueString()}.png`
          link.target = '_blank'
          link.click()
        })
        .then(() => {
          return axios.post(`/business/${this.businessSlug}/ads/${adId}/events?v=${this.randUnique()}`,
            {
              event: 'download'
            })
        })
    },
    publishAd (imageUrl, channel, resolve) {
      if (process.env.NODE_ENV === 'development') {
        imageUrl = 'https://staging-api.hellopeter.com/review-attachments/13595a36a204a3df4609ee35e2c3a337.png'
      }

      let ShareComponent = Vue.extend(window.SocialSharing)
      let ShareComponentInst = new ShareComponent({
        propsData: {url: imageUrl}
      })
      let shareOn = ''
      if (channel === 'fb_feed') {
        shareOn = 'facebook'
      } else if (channel === 'twitter') {
        shareOn = 'twitter'
      } else if (channel === 'linkedin') {
        shareOn = 'linkedin'
      }
      ShareComponentInst.share(shareOn)
      ShareComponent = null
      ShareComponentInst = null
      resolve()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/social-integration/social-ads/mixin.js